<template lang="pug">
div
    .alert.alert-warning(v-if="err") {{err.message}}
    .alert.alert-success(v-if="successMessage") {{successMessage}}
    .card
        .card-header
            h5.mb-0 Allowed Email Domains
        .card-body
            .selector-block.mb-3
                label Biobank
                select.form-control(v-model="domainsBiobank", @change="loadDomains")
                    option(value="", disabled) Select biobank
                    option(v-for="biobank in biobanks", :key="biobank.id", :value="biobank.id") {{biobank.id}} - {{biobank.name}}
            .add-domain-block.mb-3(v-if="domainsBiobank")
                label Add Allowed Domain
                form.form-inline(@submit.prevent="addDomain")
                    input.form-control.mr-2(type="text", placeholder="example.org", v-model="newDomain", required)
                    button.btn.btn-success(type="submit") Add Domain
            .domain-cards(v-if="domainsBiobank && domains.length > 0")
                .card.mb-2(v-for="domain in domains", :key="domain")
                    .card-header.d-flex.justify-content-between.align-items-center
                        div
                            h6.card-title.mb-0 {{domain}}
                            small.card-subtitle.text-muted Allowed for selected biobank
                        button.btn.btn-sm.btn-danger(@click="removeDomain(domain)") Delete
            .alert.alert-light.mb-0(v-if="domainsBiobank && domains.length === 0")
                | No allowed domains configured for this biobank.
</template>

<script>
import {getAdminBiobanks, getBiobankDomains, addBiobankDomain, deleteBiobankDomain} from "../../api";

export default {
    data() {
        return {
            err: null,
            successMessage: "",
            biobanks: [],
            domainsBiobank: "",
            domains: [],
            newDomain: ""
        };
    },
    created() {
        getAdminBiobanks()
            .then(biobanks => {
                this.biobanks = biobanks;
                if (biobanks.length > 0) {
                    this.domainsBiobank = biobanks[0].id;
                    this.loadDomains();
                }
            })
            .catch(err => this.err = err);
    },
    methods: {
        normalizeDomains(payload) {
            if (Array.isArray(payload)) {
                return payload.filter(Boolean);
            }
            if (typeof payload === "string") {
                try {
                    const parsed = JSON.parse(payload);
                    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
                } catch (error) {
                    return [];
                }
            }
            return [];
        },
        loadDomains() {
            if (!this.domainsBiobank) return;
            getBiobankDomains(this.domainsBiobank)
                .then(domains => {
                    this.err = null;
                    this.domains = this.normalizeDomains(domains);
                })
                .catch(err => this.err = err);
        },
        addDomain() {
            addBiobankDomain(this.domainsBiobank, this.newDomain)
                .then(() => {
                    this.successMessage = `Domain ${this.newDomain} added`;
                    this.newDomain = "";
                    this.loadDomains();
                })
                .catch(err => this.err = err);
        },
        removeDomain(domain) {
            deleteBiobankDomain(this.domainsBiobank, domain)
                .then(() => {
                    this.successMessage = `Domain ${domain} removed`;
                    this.loadDomains();
                })
                .catch(err => this.err = err);
        }
    }
};
</script>

<style scoped>
.selector-block {
    background: #f5f6f8;
    border: 1px solid #e3e6ea;
    border-radius: 0.25rem;
    padding: 0.75rem;
}

.add-domain-block {
    background: #ffffff;
    border: 1px dashed #cfd4da;
    border-radius: 0.25rem;
    padding: 0.75rem;
}
</style>
